import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import StepItem from '../../components/StepItem';

class StepList extends Component {
  state = {};
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    const { contentSerial } = this.props.childProps;
    this._getData(contentSerial);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return (
      this.props.childProps.contentSerial !== nextProps.childProps.contentSerial
    );
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)
    //console.log(this.props.childProps.contentSerial, nextProps.childProps.contentSerial)

    if (
      this.props.childProps.contentSerial !== nextProps.childProps.contentSerial
    ) {
      this._getData(nextProps.childProps.contentSerial);
    }
  };
  _getData = async (contentSerial) => {
    const { onStepCount } = this.props.childProps;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      alert('잘못된 경로 또는 URL입니다.');
    } else {
      const result = await this._getDataApi(contentSerial);
      const intReturn = result.data[0].intReturn;
      const stepList = result.data[0].listData;

      if (intReturn === 0) {
        onStepCount(stepList.length);
        if (this._isMounted) {
          this.setState({
            stepList,
          });
        }
      }
    }
  };

  _getDataApi = (contentSerial) => {
    const { apiUrl, loginId } = this.props;
    //const { contentSerial } = this.props.childProps;
    ////console.log(apiUrl + '/itemInfo?contentSerial=' + contentSerial)

    return axios(
      apiUrl + '/stepList?contentSerial=' + contentSerial + '&userid=' + loginId
    )
      .then((response) => response)
      .catch((error) => {
        // alert("등장인물 데이터를 로드 중 오류가 발생했습니다.");
      });
  };
  _stepClick = (cv_Idx) => {
    const { stepClick } = this.props.childProps;
    stepClick(cv_Idx);
  };
  _renderItem = () => {
    const { stepList } = this.state;

    const list = stepList.map((item, index) => {
      return (
        <StepItem
          key={index}
          contentSerial={item.contentSerial}
          stepIdx={item.stepIdx}
          stepName={item.stepName}
          stepImage={item.stepImage}
          rank={item.rank}
          stepLike={item.stepLike}
          comment={item.comment}
          cv_Idx={item.cv_Idx}
          kname={item.kname}
          stepClick={this._stepClick}
        />
      );
    });

    return list;
  };

  render() {
    const { stepList } = this.state;
    return (
      <Fragment>
        {stepList ? (
          <div className="detil_group2" style={{ paddingTop: 20 }}>
            <h1>
              등장인물{/*<span>.총*/} {/*stepList.length*/}
              {/*명</h1></span>*/}
            </h1>
            <div className="inmul_list_group">
              <div className="div_ul">
                {stepList ? this._renderItem() : null}
              </div>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(StepList));
